import i18next from 'i18next';
import { Integer } from 'type-fest';

i18next.init({
  lng: 'en',
  fallbackLng: 'en',
  debug: true,
  resources: {
    en: {
      translation: {
        plurals: {
          days: 'day',
          days_other: 'days',
          upper_days: 'Day',
          upper_days_other: 'Days',
          days_with_count: '{{count}} day',
          days_with_count_other: '{{count}} days',
          upper_days_with_count: '{{count}} Day',
          upper_days_with_count_other: '{{count}} Days',
        },
      },
    },
  },
});

function getPluralizedText(key: string, count: number, additionalOptions = {}) {
  return i18next.t(key, { count, ...additionalOptions });
}

export function getDaysText(count: number) {
  return getPluralizedText('plurals.days_with_count', count);
}

export function getUpperDaysText(count: number) {
  return getPluralizedText('plurals.upper_days_with_count', count);
}
